<template>
    <div>
        <Card>
            <p slot="title"> Summary Kartu Piutang  </p>
            <ButtonGroup>
                <Button type="primary" size="large" @click="changeSummaryType('summaryMarking')">
                    <Icon type="ios-arrow-back"></Icon>
                    Summary Marking
                </Button>
                <Button type="primary" size="large" @click="changeSummaryType('summaryMarkingAll')">
                    Summary All Marking
                    <Icon type="ios-arrow-forward"></Icon>
                </Button>
            </ButtonGroup>

            <Row type="flex" justify="space-between" style="margin: 12px 0">
                <Col span="10">
                    <transition name="move-right">
                        <div v-show="isHotSummaryMarking">
                            <ButtonGroup class="custom-group-parent">
                                <Button class="custom-group">Marking</Button>
                                <Select
                                    style="width: 300px;"
                                    v-model="markingIdSelected"
                                    filterable
                                    :remote-method="getMarkingByCode"
                                    :loading="isLoadingReceivable"
                                    @on-change="getSummaryMarkings()" >
                                    <Option v-for="option in optionMarkings"
                                        :value="option.value" :key="option.value">{{option.label}} - Saldo Akhir : {{option.balance | currency}}</Option>
                                </Select>
                            </ButtonGroup>
                        </div>
                    </transition>

                    <transition name="move-right">
                        <div v-show="isHotSummaryAllMarking">
                            <ButtonGroup class="custom-group-parent">
                                <Button class="custom-group">Tgl. Invoice</Button>
                                <Date-picker
                                    v-model="summaryDate"
                                    style="width: 138px;"
                                    type="date"
                                    format="yyyy-MM-dd"
                                    @on-change="getSummaryAllMarkings()">
                                </Date-picker>
                            </ButtonGroup>
                        </div>
                    </transition>
                </Col>
                <Col span="6">
                    <Spin size="large" v-show="isLoadingReceivable"></Spin>
                </Col>
                <Col span="6">
                </Col>
            </Row>

            <Card v-if="summaryMarkings.length != 0" v-show="isHotSummaryMarking">
                <!-- <Row type="flex" align="middle" :gutter="24" style="margin: 0 0 12px 0;">
                    <Col span="4">
                        <RadioGroup v-model="phone">
                            <Radio label="all">
                                <span>All</span>
                            </Radio>
                            <Radio label="fcl">
                                <span>FCL</span>
                            </Radio>
                            <Radio label="lcl">
                                <span>LCL</span>
                            </Radio>
                        </RadioGroup>
                    </Col>
                    <Col span="4">
                        <Select placeholder="SPJM + 3" v-model="idTemp">
                            <Option v-for="option in optionTemps"
                                :value="option.value" :key="option.id">{{option.label}}</Option>
                        </Select>
                    </Col>
                    <Col span="4">
                        <Select placeholder="All" v-model="idTemp">
                            <Option v-for="option in optionTemps"
                                :value="option.value" :key="option.id">{{option.label}}</Option>
                        </Select>
                    </Col>
                    <Col span="4">
                        <Select placeholder="Load date" v-model="idTemp">
                            <Option v-for="option in optionTemps"
                                :value="option.value" :key="option.id">{{option.label}}</Option>
                        </Select>
                    </Col>
                    <Col span="4">
                        <Date-picker v-model="paymentDate"
                            type="date"
                            placeholder="Tgl. Mulai"
                            format="dd/MM/yyyy">
                        </Date-picker>
                    </Col>
                    <Col span="4">
                        <Date-picker v-model="paymentDate"
                            type="date"
                            placeholder="Tgl. Akhir"
                            format="dd/MM/yyyy">
                        </Date-picker>
                    </Col>
                </Row> -->
                <!-- <div>
                    <Alert show-icon>Saldo Akhir = {{ lastBalance | currency }}</Alert>
                </div> -->
                <div>
                    <button type="button" @click="generateExcelMarking" class="ivu-btn ivu-btn-default ivu-btn-small" style="margin-right: 5px;"> <span>Generate XLSX</span></button>
                    <br/><br/>
                </div>
                <div
                    v-show="depositRemaining > 0">
                    <Alert type="warning" show-icon>Deposit = {{ depositRemaining | currency }}</Alert>
                    <Alert show-icon>Balance - Deposit = {{ (countBalance - depositRemaining) | currency }}</Alert>
                </div>

                <!-- Handsontable -->
                <cReceivableHotList
                    :key="componentKey"
                    :hotHeaders="headerSummaryMarking"
                    :hotColumns="columnSummaryMarking"
                    :receivableLists="summaryMarkings"
                    :customizeRows="lastTrxOfMonth"
                    :isType="'isSummaryMarking'">
                </cReceivableHotList>
            </Card>

            <Card v-if="summaryAllMarkings.length != 0" v-show="isHotSummaryAllMarking">

              <div>
              <button type="button" @click="generateExcelAllMarking" class="ivu-btn ivu-btn-default ivu-btn-small" style="margin-right: 5px;"> <span>Generate XLSX</span></button>
              <br/><br/>
                    <Alert show-icon>Total Mutasi Rekening = {{ totalMutasiRekening | currency }}</Alert>
                </div>
                <!-- Handsontable -->
                <cReceivableHotList
                    :key="componentKey"
                    :hotHeaders="headerSummaryAllMarking"
                    :hotColumns="columnSummaryAllMarking"
                    :receivableLists="summaryAllMarkings"
                    :invoiceSummaryDate="summaryDate"
                    :isType="'isSummaryAllMarking'">
                </cReceivableHotList>
            </Card>
        </Card>
    </div>
</template>

<script>
import {HTTP} from '@/components/http-lib'
import cReceivableHotList from '@/components/receivable/cReceivableHotList';
import _ from 'lodash'
import moment from 'moment'
import * as XLSX from 'xlsx'


const numeral = require('numeral');
var axios = require('axios');

export default {
    components : {
        cReceivableHotList
    },
    data: () => ({
        isHotSummaryMarking: false,
        isHotSummaryAllMarking: false,
        optionMarkings : [],
        // summary marking
        markingIdSelected : '',
        lastBalance: 0,
        headerSummaryMarking: ["Tanggal", "No. Container", "Keterangan", "No. Rekening", "Debit", "Kredit", "Saldo"],
        columnSummaryMarking: [
            {
                data: "invoiceDate",
                type: "text",
                // type: "date",
                // dateFormat: 'DD/MM/YYYY',
                // correctFormat: true,
                readOnly: true
            },
            {
                data: "containerNumber",
                type: "text",
                readOnly: true
            },
            {
                data: "description",
                type: "text",
                readOnly: true
            },
            {
                data: "no_rek",
                type: "text",
                readOnly: true
            },
            {
                data: "debitAmount",
                type: "text",
                readOnly: true
            },
            {
                data: "creditAmount",
                type: "text",
                readOnly: true
            },
            {
                data: "balance",
                type: "text",
                readOnly: true
            },
        ],
        summaryMarkings: [],
        lastTrxOfMonth: [],

        // summary all marking
        summaryDate : "",
        headerSummaryAllMarking: ["Marking", "Saldo - Deposit", "Saldo + Deposit", "ID"],
        columnSummaryAllMarking: [
            {
                data: "markingheadercode",
                type: "text",
                readOnly: true,
            },
            {
                data: "deposit",
                type: "text",
                readOnly: true,
                className: 'htRight',
            },
            {
                data: "balance",
                type: "text",
                readOnly: true,
                className: 'htRight',
            },
        ],
        summaryAllMarkings: [],
        summaryAllMarkingsXlsx: [],
        totalMutasiRekening: "",

        componentKey: 0,
        isLoadingReceivable: false,

        depositRemaining : Number,
        countBalance  : Number,

        phone: 'all',
        idTemp: '',
        optionTemps : [],
        filenameAllMarking: `summary-all-marking-` + Date.now(),
        filenameMarking: `summary-marking-` + Date.now(),
        // paymentDate: moment(Date).format('YYYY/MM/DD'),
    }),
    methods: {
        changeSummaryType: function(type){
            if (type == "summaryMarking") {
                this.isHotSummaryMarking = true;
                this.isHotSummaryAllMarking = false;
            } else {
                this.isHotSummaryMarking = false;
                this.isHotSummaryAllMarking = true;
            }
        },
        getAllMarking: function() {
            HTTP
            .get('marking/getAll')
            .then(response => {
                let data = response.data;
                let list = [];
                let comparer = '';

                for (let index = 0; index < data.length; index++) {
                    if (comparer == data[index].markingheaderid) {
                        continue;
                    }

                    let temp = {
                        value: data[index].markingheaderid,
                        label: data[index].markingheadercode
                    };

                    list.push(temp);
                    comparer = data[index].markingheaderid;
                }

                this.optionMarkings = list;
            })
            .catch(e => {
                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
            })
        },
        getMarkingByCode: _.debounce(
            function (query) {
                if (query !== '') {
                    this.isLoadingReceivable = true;
                    HTTP
                    .post('marking/getBySnapshotWithLastBalance', {
                        markingHeaderCode: query,
                        subbranchcode: this.subbranchcode
                    })
                    .then(response => {
                        this.isLoadingReceivable = false;
                        let data = response.data;

                        const list = data.map(item => {
                            return {
                                value: item.markingheaderid,
                                label: item.markingheadercode,
                                balance: item.balance
                            };
                        });

                        this.optionMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                    })
                    .catch(e => {
                        this.isLoadingReceivable = false;
                        this.$Notice.error({
                            title: "Error",
                            desc: e,
                            duration: 5
                        });
                    })
                } else {
                    this.optionMarkings = [];
                }
            }, 400
        ),
        getReceivable: function(){
            if(this.markingIdSelected !== ''){
                return HTTP.get('receivable/show/' + this.markingIdSelected)
            } else {
                this.receivables = []
            }
        },
        getDepositRemaining: function(){
            if(this.markingIdSelected !== ''){
                return HTTP.get('deposit/remaining/' + this.markingIdSelected)
            } else {
                this.depositRemaining = 0;
            }
        },
        isSettled : function (invoice){
            if(invoice != null){
                if(invoice.settledDate != null){
                        return true;
                }
            }
        },
        showDateFormatted : function(stringToFormat){
            let dateToFormat = moment(stringToFormat, 'YYYY-MM-DD').toDate();
            return moment(dateToFormat).format("DD MMM YYYY")
        },
        getSummaryMarkings: function(){
            let parent = this;

            if(this.markingIdSelected == ''){
                return;
            }

            this.isLoadingReceivable = true;

            axios.all([
                this.getReceivable(),
                this.getDepositRemaining()
            ]).then(axios.spread((receivableRes, depositRemainingRes) => {
                console.log({receivableRes});
                let receivables = []
                let countBalance = 0;

                let lastTrxIndex = 0;
                let lastTrxPerMonth = '';
                let lastTrxOfMonthTemp = []

                _.forEach(receivableRes.data, function(value, index) {
                    let invoicefee = value.invoice != null ? value.invoice.invoicefee : 0;
                    let debitAmount = value.debitAmount;
                    let creditAmount = value.creditAmount;
                    let totalvolume = value.invoice != null ? value.invoice.totalvolume : 0;
                    let isSettled = parent.isSettled(value.invoice_due)
                    let description = value.description
                    let containerNumber = value.invoice != null ? value.invoice.packaging_list.container_loading.containernumber : '-'
                    let invoiceDate = value.invoice != null ? parent.showDateFormatted(value.invoice.invoicedate) : '-'

                    if(value.invoice != null)
                    {
                        description += " (vol = " + numeral(totalvolume).format('0.000');

                        if(invoicefee != debitAmount){
                            description += ", inv = " + numeral(invoicefee).format('0,0')
                        }

                        description += ")"
                    }

                    //Faisal 12 Januari : Deposit dari Klaim tidak mempengaruhi perhitungan balance
                    if((value.type == 'DEP' && value.claimId != null) || value.isCalculated == 0 || description.includes('Penarikan')) {

                    } else {
                      let subBalance = (debitAmount - value.creditAmount)
                      countBalance = (countBalance + subBalance)
                    }

                    let arrayDescriptionContainer = '';

                    if(value.payment != null){
                        if(value.payment.payment_allocate != null){
                            arrayDescriptionContainer = value.payment.payment_allocate
                        }
                    }

                    _.forEach(arrayDescriptionContainer, function(paymentAllocate) {
                        if(paymentAllocate.invoice_due != null){
                            description += ' - '+paymentAllocate.invoice_due.receivable.description
                        } else {
                            description += ' <font style="color:red">- NOT_FOUND </font>'

                            var errorMessage = 'Transaksi tgl ' + parent.showDateFormatted(value.transactionDate) + ' ada Invoice yang berubah';

                            parent.$Notice.warning({
                                title: "Perhatian",
                                desc: errorMessage,
                                duration: 0
                            });

                        }
                    })

                    let receivable = {
                        markingHeaderId : value.markingHeaderId,
                        invoicefee : numeral(invoicefee).format('0,0'),
                        isSettled : isSettled,
                        markingheadercode : value.marking_header.markingheadercode,
                        description : description,
                        debitAmount : numeral(debitAmount).format('0,0'),
                        creditAmount : numeral(creditAmount).format('0,0'),
                        balance : numeral(countBalance).format('0,0'),
                        invoiceDate: invoiceDate,
                        containerNumber: containerNumber
                    }
                    receivables.push(receivable);

                    // get last transaction of month from invoice date
                    if (invoiceDate != '-') {
                        let lastTrxPerMonthPrefix = new Date(invoiceDate).getMonth();

                        if (lastTrxPerMonth != lastTrxPerMonthPrefix) {
                            lastTrxOfMonthTemp[lastTrxIndex] = index;
                            lastTrxIndex++;
                        } else {
                            lastTrxOfMonthTemp[lastTrxIndex-1] = index;
                        }

                        lastTrxPerMonth = lastTrxPerMonthPrefix;
                    }
                });

                this.lastTrxOfMonth = lastTrxOfMonthTemp;
                console.log("this.lastTrxOfMonth: ", this.lastTrxOfMonth);

                parent.depositRemaining = depositRemainingRes.data.remaining
                parent.countBalance = countBalance

                this.summaryMarkings = receivables;
                this.lastBalance = receivables[receivables.length - 1].balance;
                this.componentKey += 1; // re-render compononent handsontable
                this.isLoadingReceivable = false;
            }))
            .catch(e => {
                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
            });

        },
        getSummaryAll: function(){
            if(this.summaryDate !== ''){
                return HTTP.post('receivable/getSummaryAll', {
                    transactionDate: this.summaryDate,
                })
            } else {
                this.summaryAllMarkings = []
                this.summaryAllMarkingsXlsx = []
            }
        },
        getPendingList: function(){
            if(this.summaryDate !== ''){
                return HTTP.post('paymentPending/getTotalSummary', {
                    transactionDate: this.summaryDate,
                })
            } else {
                this.summaryAllMarkings = []
                this.summaryAllMarkingsXlsx = []
            }
        },
        getSummaryAllMarkings: function(){
            this.summaryDate = moment(this.summaryDate, 'YYYY-MM-DD').format("YYYY-MM-DD");
            console.log('summmaryDate: ', this.summaryDate);

            if(this.summaryDate == ''){
                return;
            }

            this.isLoadingReceivable = true;

            axios.all([
                this.getSummaryAll(),
                this.getPendingList()
            ]).then(axios.spread((summaryRes, pendingListRes) => {
                console.log({summaryRes});
                console.log({pendingListRes});
                let receivableAll = []
                let receivableAllXlsx = []

                _.forEach(summaryRes.data, function(value) {
                    let temp = {
                        markingheadercode : value.marking,
                        balance: numeral(value.balance).format('0,0'),
                        deposit: numeral(value.balance - value.deposit).format('0,0'),
                        markingheaderid : value.markingheaderid,
                    }

                    let tempXlsx = {
                        markingheadercode : value.marking,
                        balance: parseInt(value.balance),
                        deposit: parseInt(value.balance - value.deposit),
                        markingheaderid : value.markingheaderid,
                    }

                    receivableAll.push(temp);
                    receivableAllXlsx.push(tempXlsx);
                });

                this.summaryAllMarkings = receivableAll;
                this.summaryAllMarkingsXlsx = receivableAllXlsx;
                this.totalMutasiRekening = pendingListRes.data.totalMutasi;

                this.componentKey += 1; // re-render compononent handsontable
                this.isLoadingReceivable = false;
            }))
            .catch(e => {
                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
            });

        },
        generateExcelMarking : function() {
        //   console.info("hello world", this.summaryMarkings);

        let listSummaryMarking = _.map(this.summaryMarkings, obj => {
            let pickedObj = _.pick(obj, ["invoiceDate", "containerNumber", "description", "debitAmount", "creditAmount", "balance"]);
            
            pickedObj.balance = parseInt(pickedObj.balance.replace(/,/g, ''));
            pickedObj.creditAmount = parseInt(pickedObj.creditAmount.replace(/,/g, ''));
            pickedObj.debitAmount = parseInt(pickedObj.debitAmount.replace(/,/g, ''));

            return pickedObj;
            });
            
          const data = XLSX.utils.json_to_sheet(listSummaryMarking)
          const wb = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(wb, data, 'List Summary Marking')

          XLSX.utils.sheet_add_aoa(data, [["Tanggal", "No. Container", "Keterangan", "Debit", "Kredit", "Saldo"]])

          XLSX.writeFile(wb, this.filenameMarking + '.xlsx')
        },

        generateExcelAllMarking : function() {
          // console.info("hello world", this.summaryAllMarkings);
          let listSummaryMarking = _.map(this.summaryAllMarkingsXlsx, obj => _.pick(obj, ["markingheadercode", "deposit", "balance"]))

          const data = XLSX.utils.json_to_sheet(listSummaryMarking)
          const wb = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(wb, data, 'List Summary All Marking')

          XLSX.utils.sheet_add_aoa(data, [["Marking", "saldo - deposit", "saldo + deposit"]])

          XLSX.writeFile(wb, this.filenameAllMarking + '.xlsx')
        }
    },
    filters: {
        currency: function (value) {
            if (!value) return ''
            return numeral(value).format('0,0')
        }
    },
    mounted() {
        this.getAllMarking()

    }
}

</script>



// WEBPACK FOOTER //
// ReceivableHotList.vue?d8620096